import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import {
  cmes,
  formatoMonto,
  formatMoneda,
  validaMonto,
  validaSoloNumero,
} from "../../util/varios";
import axios from "axios";
import moment from "moment";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";

const ModalActuDolar = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const mesActual = parseInt(moment(fechaSistema).format("MM"));

  const [operacion, setOperacion] = useState();
  const txtAnio = useRef();
  const txtMes = useRef();
  const txtFecha = useRef();
  const txtValor = useRef();
  const [activate, setActivate] = useState(false);
  const [disabled, setDisabled] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cancelar = () => {
    props.onHideCancela();
    blanquear();
  };

  const blanquear = () => {
    txtAnio.current.value = "";
    txtMes.current.value = "";
    txtFecha.current.value = "";
    txtValor.current.value = "";
  };

  const actualizarRenta = () => {
    let endpoint = `${op.conexion}/api/valordolarbcv/actualizar/${operacion}`;
    let body;
    setActivate(true);

    body = {
      ani: txtAnio.current.value,
      me: txtMes.current.value,
      val: parseFloat(
        txtValor.current.value.replace(/\./g, "").replace(",", ".")
      ),
      fech: txtFecha.current.value,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "valorpetro_pkey"'
          ) {
            mensaje = "Ya existe un registro con esta fecha";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: mensaje,
          icono: "informacion",
        });
        setActivate(false);
      });
  };

  const validar = () => {
    let sigue = true;

    if (txtAnio.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El año no debe estar vacio",
        icono: "informacion",
      });
      txtAnio.current.focus();
      sigue = false;
    } else if (
      txtAnio.current.value.length < 4 ||
      parseInt(txtAnio.current.value) >
        parseInt(
          moment(JSON.parse(localStorage.getItem("fechasistema"))).format(
            "YYYY"
          )
        )
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar un año valido",
        icono: "informacion",
      });
      txtAnio.current.focus();
      sigue = false;
    } else if (txtMes.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El mes no debe estar vacio",
        icono: "informacion",
      });
      txtMes.current.focus();
      sigue = false;
    } else if (parseInt(txtFecha.current.value) === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      txtFecha.current.focus();
      sigue = false;
    } else if (txtValor.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El valor no debe estar vacio",
        icono: "informacion",
      });
      txtValor.current.focus();
      sigue = false;
    } else if (txtValor.current.value === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El valor de ser mayor a 0",
        icono: "informacion",
      });
      txtValor.current.focus();
      sigue = false;
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseSi = () => {
    actualizarRenta();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    cancelar();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion === 1 || props.operacion === 2) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registrar Valor Dolar BCV"
              : operacion === 2
              ? "Modificar  Valor Dolar BCV"
              : operacion === 3
              ? "Eliminar Valor Dolar BCV"
              : "Consultar Valor Dolar BCV"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <div className="container-fluid py-2">
          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto">
              <i className="fas fa-lg px-2 fa-clipboard-list"></i>Datos del
              Valor Dolar BCV
            </legend>

            <div className="col-md-12 row m-0">
              <div className="input-group py-1 input-group-sm col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  <i className="far fa-lg px-1 fa-calendar"></i>Año:
                </label>
                <input
                  type="text"
                  className="form-control bg-light"
                  autoComplete="off"
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3
                      ? true
                      : false
                  }
                  aria-label="Sizing example input"
                  ref={txtAnio}
                  aria-describedby="inputGroup-sizing-sm"
                  defaultValue={props.petro ? props.petro.anio : anioActu}
                  onKeyPress={handleInputNumChange}
                  onBlur={handleInputNumChange}
                  maxLength={4}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-6">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  <i className="far fa-lg px-1 fa-calendar"></i>Mes:
                </label>
                <select
                  className="form-select bg-light"
                  aria-label="Default select example"
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3
                      ? true
                      : false
                  }
                  ref={txtMes}
                  defaultValue={props.petro ? props.petro.mes : mesActual}
                >
                  <option value="">Seleccionar</option>
                  <option value="1">ENERO</option>
                  <option value="2">FEBRERO</option>
                  <option value="3">MARZO</option>
                  <option value="4">ABRIL</option>
                  <option value="5">MAYO</option>
                  <option value="6">JUNIO</option>
                  <option value="7">JULIO</option>
                  <option value="8">AGOSTO</option>
                  <option value="9">SEPTIEMBRE</option>
                  <option value="10">OCTUBRE</option>
                  <option value="11">NOVIEMBRE</option>
                  <option value="12">DICIEMBRE</option>
                </select>
              </div>
            </div>

            <div className="col-md-12 row m-0">
              <div className="input-group py-1 input-group-sm col-sm-7 px-0">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  <i className="far fa-lg px-1 fa-calendar"></i>Fecha de
                  Aplicación:
                </label>
                <input
                  type="date"
                  ref={txtFecha}
                  className="form-control bg-light"
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3
                      ? true
                      : false
                  }
                  max={moment(fechaSistema).format("YYYY-MM-DD")}
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  defaultValue={
                    props.petro
                      ? props.petro.fechaaplic !== null
                        ? moment(props.petro.fechaaplic).format("YYYY-MM-DD")
                        : moment(fechaSistema).format("YYYY-MM-DD")
                      : moment(fechaSistema).format("YYYY-MM-DD")
                  }
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-5 px-1">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  <i className="fas fa-lg px-1 fa-money-bill-wave-alt"></i>
                  Valor:
                </label>
                <input
                  type="text"
                  ref={txtValor}
                  className="text-right form-control"
                  autoComplete="off"
                  disabled={disabled}
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  defaultValue={
                    props.petro
                      ? props.petro.valor !== null
                        ? formatMoneda(
                            props.petro.valor.replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                        : ""
                      : ""
                  }
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-10 m-0 row  py-1">
          <button
            type="button"
            style={{ margin: "1px" }}
            disabled={operacion === 4 ? true : false}
            onClick={validar}
            className="col-md-5 btn btn-sm btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>
          <button
            type="button"
            style={{ margin: "1px" }}
            onClick={cancelar}
            className="col-md-5 btn btn-danger btn-sm rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
export default ModalActuDolar;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalActualizarDolar.js